class BarrierFAQ extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    // Preserve exclusive expansion in browsers without native details grouping.
    const questions = [...this.querySelectorAll('details.bfaq__item')];
    questions.forEach((question) => {
      question.addEventListener('toggle', () => {
        if (!question.open) return;
        questions.forEach((other) => {
          if (other !== question) other.open = false;
        });
      }, { signal });
    });
    this.more = this.querySelector('[data-faq-more]');
    this.expandButton = this.querySelector('[data-faq-expand]');
    this.collapseButton = this.querySelector('[data-faq-collapse]');
    if (!this.more || !this.expandButton || !this.collapseButton) return;
    this.expandButton.addEventListener('click', () => {
      this.more.hidden = false;
      this.more.classList.add('bfaq__visible');
      this.expandButton.hidden = true;
      this.expandButton.setAttribute('aria-expanded', 'true');
      this.collapseButton.hidden = false;
      this.more.querySelector('summary').focus({ preventScroll: true });
    }, { signal });
    this.collapseButton.addEventListener('click', () => {
      this.more.querySelectorAll('details[open]').forEach((question) => { question.open = false; });
      this.more.hidden = true;
      this.more.classList.remove('bfaq__visible');
      this.collapseButton.hidden = true;
      this.expandButton.hidden = false;
      this.expandButton.setAttribute('aria-expanded', 'false');
      this.expandButton.focus({ preventScroll: true });
      this.expandButton.scrollIntoView({ block: 'nearest', behavior: 'instant' });
    }, { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
  }
}

if (!customElements.get('barrier-faq')) customElements.define('barrier-faq', BarrierFAQ);
